import { useKeycloak } from "@react-keycloak/ssr";
import { KeycloakInstance } from "keycloak-js";
import { useRouter } from "next/router";
import { ServerSidePropsContext } from "providers/ServerSideProps";
import * as React from "react";
import { useEffect } from "react";
import { decrypt } from "utils/ecryption";

type PianoInitContextType = {
  tp: any;
};

export const PianoInitContext = React.createContext<PianoInitContextType>(
  {} as PianoInitContextType
);

const PianoInitProvider = (props) => {
  const [tinypass, setTinypass] = React.useState();
  const { keycloak } = useKeycloak<KeycloakInstance>();
  const pianoUrl = process.env.NEXT_PUBLIC_PIANO_URL;
  const serverSideContext = React.useContext(ServerSidePropsContext);
  const isPaywall =
    serverSideContext?.site?.pageConfig?.featureRadioSelectPaywall;
  const router = useRouter();

  const handleLogin = async () => {
    try {
      await keycloak?.login({
        redirectUri: `${window.location.href}`,
      });
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  React.useEffect(() => {
    let tp = window.tp || [];

    tp.push(["setUseTinypassAccounts", false]);
    tp.push(["setUsePianoIdUserProvider", false]);
    tp.push(["setUsePianoIdLiteUserProvider", true]);
    tp.push(["setPageURL", window.location.href]);

    if (isPaywall === "PIANO") {
      if (tp?.aid === undefined || tp === undefined) {
        (function (src) {
          var a = document.createElement("script");
          a.type = "text/javascript";
          a.async = true;
          a.id = "pianoJs";
          a.src = src ? src : "";
          var b = document.getElementsByTagName("script")[0];
          b.parentNode?.insertBefore(a, b);
        })(pianoUrl);
      }

      setTinypass(tp);
    } else {
      var b = document.getElementsByTagName("script");
      for (let i = 0; i < b.length; i++) {
        if (b[i].innerHTML.indexOf("tinypass") !== -1) {
          b[i].remove();
        }
      }
    }
  }, [router.asPath, keycloak]);

  useEffect(() => {
    let tp = window.tp || [];
    tp.push([
      "addHandler",
      "loginRequired",
      function (params) {
        handleLogin();
      },
    ]);
    tp.push([
      "init",
      function () {
        if (keycloak) {
          if (tp.pianoId.isUserValid() == false) {
            tp.pianoId?.loginByToken(decrypt(keycloak?.token)).then((res) => {
              tp.experience.init();
            });
          }
        } else {
          tp.experience.init();
        }
      },
    ]);
  }, [keycloak]);
  return (
    <PianoInitContext.Provider value={{ tp: tinypass }}>
      {props.children}
    </PianoInitContext.Provider>
  );
};

export default PianoInitProvider;
